import { NotificationModel, PaginatedResponse } from '@arpeggi/shared'
import axios from 'axios'
import { GetNotificationsParams } from '../types'

export const getNotifications = async (userId: number, params: GetNotificationsParams) => {
  const { data } = await axios.get<PaginatedResponse<NotificationModel>>(
    `/api/v2/users/${userId}/notifications`,
    { params }
  )

  return data
}
